/**
 * Holds the first next_question MQTT payload if it arrives before
 * RapFireGameLive has subscribed / loaded lobbyQuestions.
 */
let pendingNextQuestion = null;

export const stashRapFireNextQuestion = (payload) => {
  if (!payload) return;
  pendingNextQuestion = payload;
};

export const takeRapFireNextQuestion = () => {
  const payload = pendingNextQuestion;
  pendingNextQuestion = null;
  return payload;
};

export const peekRapFireNextQuestion = () => pendingNextQuestion;
